import { CSCLeadTimeStrategy } from './csc';
import { DefaultLeadTimeStrategy } from './default';
import { RAFLeadTimeStrategy } from './raf';
import type { LeadTimeStrategyMap } from './types';
import { WWPLeadTimeStrategy } from './wwp';

export const strategies: LeadTimeStrategyMap = {
  default: DefaultLeadTimeStrategy,
  RAF: RAFLeadTimeStrategy,
  CSC: CSCLeadTimeStrategy,
  WWP: WWPLeadTimeStrategy,
};
